import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export class PasswordsMatchValidator {
  static createValidator(): ValidatorFn {
    return (abstract: AbstractControl): ValidationErrors | null => {
      const group = abstract as FormGroup;
      const confirmPassword: string = group.get("confirmPassword")?.value;
      const password: string = group.get("newPassword")?.value;
      if (password !== confirmPassword) {
        group.get("confirmPassword")?.setErrors({ pwCheck: true });
      } else {
        group.get("confirmPassword")?.setErrors(null);
      }
      return null;
    };
  }
}
